import { filterDataByRequiredFields } from '@/utils/filter'
import { UnityCommonHeadersType, getUnityCommonHeaders } from '@/utils/unityBridgeUtils'

export interface ApiState {
  commonHeaders: UnityCommonHeadersType
}

const state: ApiState = {
  commonHeaders: {
    uid: 0, // 用户uid
    version: '', // APP版本(1.47.1)
    pf: 3, // 平台类型 1:android; 2:ios; 3 web
    deviceId: '', // 设备ID（业务侧自定义生成规则）
    model: '', // 手机型号
    idfa: '', // 广告标示符 IDFA
    uuid: '', // 客户端生成的uuid标识符
    apil: '0', // API Level
    aid: '', // 安卓ID
    pkgId: '', // 包id，只要包不同，pkg_id就不同，一个大区里面可能有不止一个包
    mktRegion: '', // 市场开放的大区。sea=东南亚，me=中东
    nlid: '' // 新言设备ID
  }
}

const mutations = {
  SET_COMMON_HEADERS(state: ApiState, data: UnityCommonHeadersType): void {
    console.log('weelife-common-headers', data)
    state.commonHeaders = filterDataByRequiredFields(data, 1, ['uid', 'version', 'pf'])
  }
}

const actions = {
  /** 设置公用请求头部参数 */
  actionUnityCommonHeaders({ commit }: any): Promise<unknown> {
    return new Promise((resolve) => {
      getUnityCommonHeaders().then(res => {
        if (res) {
          commit('SET_COMMON_HEADERS', res)
          resolve(res)
        }
      })
    })
  }
}

export const api = {
  namespaced: true,
  state,
  mutations,
  actions
}
